var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrafik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Grafik__Icn/40px/Grafik",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Grafik__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Grafik__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31,12 L31,28 L9,28 L9,12 L31,12 Z M29,14 L11,14 L11,26 L29,26 L29,14 Z M17,19.25 L21.6,22.7 L20.4,24.3 L17,21.75 L13.6,24.3 L12.4,22.7 L17,19.25 Z M24.5,15 C26.4329966,15 28,16.5670034 28,18.5 C28,20.4329966 26.4329966,22 24.5,22 C22.5670034,22 21,20.4329966 21,18.5 C21,16.5670034 22.5670034,15 24.5,15 Z M24.5,17 C23.6715729,17 23,17.6715729 23,18.5 C23,19.3284271 23.6715729,20 24.5,20 C25.3284271,20 26,19.3284271 26,18.5 C26,17.6715729 25.3284271,17 24.5,17 Z",
    id: ".._.._src_svg_Icn_40px_Grafik__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrafik);
export default __webpack_public_path__ + "static/media/Grafik.8b9fe473a4a21db11b708355b111b7b4.svg";
export { ForwardRef as ReactComponent };